<template>
	<div class="button-holder" v-if="continueLink">
		<a v-if="!confirmButtonIsSubmit" :href="continueLink" class="button button-xl btn-full red" :id="id" v-bind:disabled="buttonDisabled" v-bind:aria-disabled="buttonDisabled">
			{{ this.$store.state.continueButtonText }}
		</a>
		<button v-if="confirmButtonIsSubmit" :type="!!active ? 'submit' : 'button'" class="button button-xl btn-full" v-bind:class="{loading: currentlyLoading, red: active, grey: !active}" v-bind:disabled="buttonDisabled" v-bind:aria-disabled="buttonDisabled">
			{{ this.$store.state.continueButtonText }}
		</button>
	</div>
</template>

<script>
export default {
	name: 'ButtonLg',
	props: {
		id: String,
		currentlyLoading: Boolean,
		active: {
			type: Boolean,
			default: true
		},
	},
	computed: {
		buttonDisabled(){
			return this.currentlyLoading || !this.active;
		},
		confirmButtonIsSubmit() {
			return this.$store.state.confirmButtonIsSubmit
		},
		continueLink() {
			return this.$store.state.continueButton
		},
	}
}
</script>